import _slicedToArray from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { createContainer } from "unstated-next";
import classNames from "classnames";
import { useScreenSize } from "./useScreenSize";
/**
 * Manages the expanded and open state of the Webapp UI
 */

function useWebUi() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    expanded: true,
    open: false
  };

  var _useState = useState(initialState.expanded),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = useState(initialState.open),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var screenSize = useScreenSize();
  useEffect(function () {
    if (screenSize === "medium") {
      setExpanded(false);
    } else {
      setExpanded(true);
    }
  }, [screenSize]);
  return {
    expanded: expanded,
    open: open,
    setExpanded: setExpanded,
    setOpen: setOpen
  };
}
/**
 * Unstated container that holds the UI State
 */


export var WebAppContext = createContainer(useWebUi);

var InnerWebAppContainer = function InnerWebAppContainer(_ref) {
  var children = _ref.children;
  var state = WebAppContext.useContainer();
  return React.createElement("div", {
    className: classNames("wa-grid-container wa-sidenav-mobile", {
      "wa-sidenav-collapsed": !state.expanded
    }),
    id: "waGridContainer",
    "data-collapse": !state.expanded
  }, children);
};

export var WAContainer = function WAContainer(_ref2) {
  var children = _ref2.children;
  return React.createElement(WebAppContext.Provider, null, React.createElement(InnerWebAppContainer, null, children));
};